export const about = {
  en: {
    tagline: 'Grow in Scripture through solo play and private family & friends quizzes',
    appInformation: 'App Information',
    version: 'Version',
    build: 'Build',
    platform: 'Platform',
    description:
      'Kingdom Bible Quiz helps you grow in biblical knowledge through solo play, private family and friends quizzes, and a steady rhythm of Scripture-based learning.',
    keyFeatures: 'Key Features',
    featureQuestions: '30,000+ Bible quiz questions',
    featureCategories: '76 biblical categories',
    featureFormats: '5 question formats',
    featureLanguages: '10 language support',
    featurePrivateMultiplayer: 'Private family & friends multiplayer',
    featureDenominations: '10 Christian denominations',
    visitWebsite: 'Visit Website',
    contactSupport: 'Contact Support',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    copyright: '© 2025 Kingdom Bible Quiz. All rights reserved.',
  },
  fr: {
    tagline: 'Progressez dans les Écritures en jouant seul ou en famille et entre amis',
    appInformation: 'Informations sur l\'application',
    version: 'Version',
    build: 'Build',
    platform: 'Plateforme',
    description: 'Kingdom Bible Quiz vous aide à approfondir votre connaissance de la Bible grâce au jeu en solo, aux quiz privés en famille et entre amis, et à un rythme régulier d\'apprentissage des Écritures.',
    keyFeatures: 'Fonctionnalités clés',
    featureQuestions: 'Plus de 30 000 questions bibliques',
    featureCategories: '76 catégories bibliques',
    featureFormats: '5 formats de questions',
    featureLanguages: '10 langues disponibles',
    featurePrivateMultiplayer: 'Multijoueur privé en famille et entre amis',
    featureDenominations: '10 confessions chrétiennes',
    visitWebsite: 'Visiter le site web',
    contactSupport: 'Contacter l\'assistance',
    privacyPolicy: 'Politique de confidentialité',
    termsOfService: 'Conditions d\'utilisation',
    copyright: '© 2026 Kingdom Bible Quiz. Tous droits réservés.',
  },
  es: {
    tagline: 'Crece en las Escrituras jugando solo o en quizzes privados con familia y amigos',
    appInformation: 'Información de la aplicación',
    version: 'Versión',
    build: 'Compilación',
    platform: 'Plataforma',
    description: 'Kingdom Bible Quiz te ayuda a crecer en el conocimiento bíblico con juego individual, quizzes privados con familia y amigos, y un ritmo constante de aprendizaje de las Escrituras.',
    keyFeatures: 'Características principales',
    featureQuestions: 'Más de 30 000 preguntas bíblicas',
    featureCategories: '76 categorías bíblicas',
    featureFormats: '5 formatos de preguntas',
    featureLanguages: 'Compatible con 10 idiomas',
    featurePrivateMultiplayer: 'Multijugador privado con familia y amigos',
    featureDenominations: '10 denominaciones cristianas',
    visitWebsite: 'Visitar el sitio web',
    contactSupport: 'Contactar con soporte',
    privacyPolicy: 'Política de privacidad',
    termsOfService: 'Términos del servicio',
    copyright: '© 2026 Kingdom Bible Quiz. Todos los derechos reservados.',
  },
  de: {
    tagline: 'Wachse in der Schrift – allein oder in privaten Quizrunden mit Familie und Freunden',
    appInformation: 'App-Informationen',
    version: 'Version',
    build: 'Build',
    platform: 'Plattform',
    description: 'Kingdom Bible Quiz hilft dir, in der Bibelkenntnis zu wachsen – mit Einzelspiel, privaten Quizrunden für Familie und Freunde und einem stetigen Rhythmus des Lernens aus der Schrift.',
    keyFeatures: 'Hauptfunktionen',
    featureQuestions: 'Über 30.000 Bibelquizfragen',
    featureCategories: '76 biblische Kategorien',
    featureFormats: '5 Fragetypen',
    featureLanguages: '10 Sprachen verfügbar',
    featurePrivateMultiplayer: 'Privater Mehrspielermodus für Familie und Freunde',
    featureDenominations: '10 christliche Konfessionen',
    visitWebsite: 'Website besuchen',
    contactSupport: 'Support kontaktieren',
    privacyPolicy: 'Datenschutzerklärung',
    termsOfService: 'Nutzungsbedingungen',
    copyright: '© 2026 Kingdom Bible Quiz. Alle Rechte vorbehalten.',
  },
  pt: {
    tagline: 'Cresça nas Escrituras jogando sozinho ou em quizzes privados com família e amigos',
    appInformation: 'Informações do aplicativo',
    version: 'Versão',
    build: 'Build',
    platform: 'Plataforma',
    description: 'O Kingdom Bible Quiz ajuda você a crescer no conhecimento bíblico com jogo individual, quizzes privados com família e amigos e um ritmo constante de aprendizado das Escrituras.',
    keyFeatures: 'Principais recursos',
    featureQuestions: 'Mais de 30.000 perguntas bíblicas',
    featureCategories: '76 categorias bíblicas',
    featureFormats: '5 formatos de perguntas',
    featureLanguages: 'Suporte a 10 idiomas',
    featurePrivateMultiplayer: 'Multijogador privado com família e amigos',
    featureDenominations: '10 denominações cristãs',
    visitWebsite: 'Visitar o site',
    contactSupport: 'Falar com o suporte',
    privacyPolicy: 'Política de privacidade',
    termsOfService: 'Termos de serviço',
    copyright: '© 2026 Kingdom Bible Quiz. Todos os direitos reservados.',
  },
  ru: {
    tagline: 'Растите в познании Писания: играйте в одиночку или в частных викторинах с семьёй и друзьями',
    appInformation: 'Информация о приложении',
    version: 'Версия',
    build: 'Сборка',
    platform: 'Платформа',
    description: 'Kingdom Bible Quiz помогает расти в знании Библии: одиночная игра, частные викторины для семьи и друзей и регулярное изучение Писания.',
    keyFeatures: 'Основные возможности',
    featureQuestions: 'Более 30 000 вопросов по Библии',
    featureCategories: '76 библейских категорий',
    featureFormats: '5 форматов вопросов',
    featureLanguages: '10 языков',
    featurePrivateMultiplayer: 'Частная игра вдвоём и больше — для семьи и друзей',
    featureDenominations: '10 христианских конфессий',
    visitWebsite: 'Открыть сайт',
    contactSupport: 'Связаться с поддержкой',
    privacyPolicy: 'Политика конфиденциальности',
    termsOfService: 'Условия использования',
    copyright: '© 2026 Kingdom Bible Quiz. Все права защищены.',
  },
  it: {
    tagline: 'Cresci nelle Scritture giocando da solo o nei quiz privati con famiglia e amici',
    appInformation: 'Informazioni sull\'app',
    version: 'Versione',
    build: 'Build',
    platform: 'Piattaforma',
    description: 'Kingdom Bible Quiz ti aiuta a crescere nella conoscenza biblica con il gioco singolo, quiz privati con famiglia e amici e un ritmo costante di studio delle Scritture.',
    keyFeatures: 'Funzionalità principali',
    featureQuestions: 'Oltre 30.000 domande bibliche',
    featureCategories: '76 categorie bibliche',
    featureFormats: '5 formati di domande',
    featureLanguages: 'Disponibile in 10 lingue',
    featurePrivateMultiplayer: 'Multigiocatore privato con famiglia e amici',
    featureDenominations: '10 confessioni cristiane',
    visitWebsite: 'Visita il sito web',
    contactSupport: 'Contatta l\'assistenza',
    privacyPolicy: 'Informativa sulla privacy',
    termsOfService: 'Termini di servizio',
    copyright: '© 2026 Kingdom Bible Quiz. Tutti i diritti riservati.',
  },
  ko: {
    tagline: '혼자 하거나 가족·친구와 비공개 퀴즈로 성경 안에서 성장하세요',
    appInformation: '앱 정보',
    version: '버전',
    build: '빌드',
    platform: '플랫폼',
    description: 'Kingdom Bible Quiz는 혼자 하는 플레이, 가족·친구와 함께하는 비공개 퀴즈, 꾸준한 말씀 학습으로 성경 지식을 키워 줍니다.',
    keyFeatures: '주요 기능',
    featureQuestions: '30,000개 이상의 성경 퀴즈 문제',
    featureCategories: '76개의 성경 카테고리',
    featureFormats: '5가지 문제 유형',
    featureLanguages: '10개 언어 지원',
    featurePrivateMultiplayer: '가족·친구와 함께하는 비공개 멀티플레이',
    featureDenominations: '10개 기독교 교단',
    visitWebsite: '웹사이트 방문',
    contactSupport: '지원팀 문의',
    privacyPolicy: '개인정보 처리방침',
    termsOfService: '서비스 이용약관',
    copyright: '© 2026 Kingdom Bible Quiz. 모든 권리 보유.',
  },
  tl: {
    tagline: 'Lumago sa Kasulatan sa pamamagitan ng solo play at pribadong quiz kasama ang pamilya at mga kaibigan',
    appInformation: 'Impormasyon ng App',
    version: 'Bersyon',
    build: 'Build',
    platform: 'Platform',
    description: 'Tinutulungan ka ng Kingdom Bible Quiz na lumago sa kaalaman sa Bibliya sa pamamagitan ng solo play, pribadong quiz kasama ang pamilya at mga kaibigan, at tuloy-tuloy na pag-aaral ng Kasulatan.',
    keyFeatures: 'Mga Pangunahing Tampok',
    featureQuestions: '30,000+ tanong sa Bible quiz',
    featureCategories: '76 na kategorya ng Bibliya',
    featureFormats: '5 format ng tanong',
    featureLanguages: 'Sumusuporta sa 10 wika',
    featurePrivateMultiplayer: 'Pribadong multiplayer para sa pamilya at mga kaibigan',
    featureDenominations: '10 denominasyong Kristiyano',
    visitWebsite: 'Bisitahin ang Website',
    contactSupport: 'Makipag-ugnayan sa Suporta',
    privacyPolicy: 'Patakaran sa Privacy',
    termsOfService: 'Mga Tuntunin ng Serbisyo',
    copyright: '© 2026 Kingdom Bible Quiz. Lahat ng karapatan ay nakalaan.',
  },
  am: {
    tagline: 'በብቻ በመጫወትና ከቤተሰብና ጓደኞች ጋር በግል ጥያቄዎች በቅዱስ መጽሐፍ ያድጉ',
    appInformation: 'የመተግበሪያ መረጃ',
    version: 'ስሪት',
    build: 'ግንባታ',
    platform: 'መድረክ',
    description: 'Kingdom Bible Quiz በብቻ በመጫወት፣ ከቤተሰብና ጓደኞች ጋር በግል ጥያቄዎችና በቋሚ የቅዱስ መጽሐፍ ትምህርት የመጽሐፍ ቅዱስ እውቀትዎን እንዲያሳድጉ ይረዳዎታል።',
    keyFeatures: 'ዋና ዋና ባህሪያት',
    featureQuestions: 'ከ30,000 በላይ የመጽሐፍ ቅዱስ ጥያቄዎች',
    featureCategories: '76 የመጽሐፍ ቅዱስ ምድቦች',
    featureFormats: '5 የጥያቄ ዓይነቶች',
    featureLanguages: '10 ቋንቋዎች ይደገፋሉ',
    featurePrivateMultiplayer: 'ለቤተሰብና ለጓደኞች የግል ብዙ ተጫዋች',
    featureDenominations: '10 የክርስትና ቤተ እምነቶች',
    visitWebsite: 'ድር ጣቢያውን ይጎብኙ',
    contactSupport: 'ድጋፍን ያግኙ',
    privacyPolicy: 'የግላዊነት መመሪያ',
    termsOfService: 'የአገልግሎት ውሎች',
    copyright: '© 2026 Kingdom Bible Quiz. መብቱ በሕግ የተጠበቀ ነው።',
  },
};
